module.exports = __webpack_public_path__ + "static/media/31JFA2.742da760.jpg";